@if (url?.length && context()) {
  <div class="container">
    <luigi-container
      [viewurl]="url"
      id="dcp-lead-form"
      webcomponent='{ "selfRegistered": true }'
      [context]="context()"
      data-cy="dcp-lead-form"
    ></luigi-container>
  </div>
  <div
    [id]="gRecaptchaId"
  ></div>
}
